
































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

import { Getter, Mutation } from 'vuex-class';

import { mapGetters } from 'vuex';
import { Photo } from '../../../models/photo';

import { photoWebservice } from '../../../webservices/photo';

import PhotoModal from './PhotoModal.vue';
import PhotoFinishedModal from './PhotoFinishedModal.vue';

import { Utils } from '../../../helpers/Utils';

@Component({
    components: {
        PhotoModal,
        PhotoFinishedModal,
    },
})
export default class PhotoOverview extends Vue {

    protected isPhotoModalActive: boolean = false;
    protected isPhotoFinishedModalActive: boolean = false;

    protected activePhoto: Photo;
    protected activeIndex: number;
    protected utils: Utils = new Utils();

    // Vuex
    @Mutation('photo/setPhotosOverview') private setPhotosOverview;
    @Mutation('configuration/removeLike') private removeLike;
    @Mutation('configuration/removeDislike') private removeDislike;

    @Getter('photo/photosOverview') private photosOverview: Photo[];
    @Getter('configuration/photosLiked') private photosLiked: Photo[];
    @Getter('configuration/photosDisliked') private photosDisliked: Photo[];
    @Getter('configuration/isPhotoLiked') private isPhotoLiked: boolean;
    @Getter('configuration/isPhotoDisliked') private isPhotoDisliked: boolean;

    @Getter('wizard/laterGoToResults') private laterGoToResults: boolean;

    @Watch('photosLiked')
    private photosChanged() {
        if (this.photosLiked.length >= 3 && this.photosDisliked.length >= 3 && !this.laterGoToResults) {
            this.isPhotoFinishedModalActive = true;
        }

        // The user could be clicking later go to results and remove one of the likes
        // In this case we need to change the set later go to results variable so the message comes again
        if (this.laterGoToResults) {
            if (this.photosLiked.length < 3 || this.photosDisliked.length < 3) {
                this.$store.commit('wizard/setLaterGoToResults', false);
            }
        }
    }

    private mounted() {
        this.loadAllPhotos();
    }

    private loadAllPhotos() {
        if (this.photosOverview.length === 0) {
            photoWebservice.getAllPhotos().then((photos) => {
                photos = photos.filter((photo) => {
                    return photo.type === 'All';
                });

                photos = this.utils.shuffleArray(photos);

                // Set the photos overview in the vuex store
                this.setPhotosOverview(photos);
            }).catch((error) => {
                console.log(error);
            });
        }
    }

    private togglePhotoModal(photo: Photo, index: number) {
        // Toggle the status of the modal view
        this.isPhotoModalActive = !this.isPhotoModalActive;

        // Set the current active photo
        this.activePhoto = photo;

        // Set the index
        this.activeIndex = index;
    }

    private togglePhotoFinishedModal() {
        this.isPhotoFinishedModalActive = !this.isPhotoFinishedModalActive;
    }

    private reset() {
        // Reset the configuration
        this.$store.commit('configuration/reset');

        // Reset the go later to photos/results
        this.$store.commit('wizard/setLaterGoToPhotos', false);
        this.$store.commit('wizard/setLaterGoToResults', false);

        // Switch the tab to the beginning
        this.$store.commit('wizard/setCurrentTab', 1);
    }

    private goToResults() {
        if (this.photosLiked.length >= 3 && this.photosDisliked.length >= 3) {
            this.$store.commit('wizard/setCurrentTab', 3);
        }
    }
}
